import { styled } from "@mui/material/styles";

import { warningColor } from "~/styles/redesignColors";

const MARK_SIZE = 14;

export const Mark = styled("span")(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flex: "none",
  width: MARK_SIZE,
  height: MARK_SIZE,
  color: warningColor(theme),
  cursor: "help",

  svg: {
    fontSize: MARK_SIZE,
  },
}));
